module.exports = __webpack_public_path__ + "img/subirfoto.17a4de58.jpg";